(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-visual"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-size-visual')) {
    customElements.define('product-size-visual', class extends HTMLElement {
      connectedCallback() {
        this.handleVariant = event => {
          const form = document.querySelector(`variant-selects[data-section="${CSS.escape(String(event.detail.sectionId))}"]`);
          if (!form || form.dataset.url !== this.dataset.productUrl) return;
          const index = Number(this.dataset.sizeOption);
          if (index < 0 || !event.detail.variant) return;
          const raw = String(event.detail.variant.options[index] || '').trim();
          const match = raw.match(/^(\d+(?:[.,]\d+)?)\s*(?:mm)?$/i);
          const number = match ? Number(match[1].replace(',', '.')) : 0;
          if (number < 20 || number > 90) return;
          this.querySelectorAll('[data-lens-value]').forEach(label => { label.textContent = `${number} mm`; });
        };
        document.addEventListener('product:variant-change', this.handleVariant);
      }
      disconnectedCallback() {
        document.removeEventListener('product:variant-change', this.handleVariant);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
